/**
 * The network grid: creature state is snapped to these steps at the end of every tick, so a
 * snapshot encodes it losslessly and a client restores the server's state bit-for-bit
 * (reconciliation replays then match the server exactly; docs/05). The steps are far below
 * anything visible: 0.1 mm, 0.1 mm/s, 1/65536 turn, 1/100 stamina.
 */
export const GRID = { pos: 1e4, vel: 1e4, dir: 1e4, stamina: 100 } as const;

const TAU = Math.PI * 2;

export const snapPos = (v: number) => Math.round(v * GRID.pos) / GRID.pos;
export const snapVel = (v: number) => Math.round(v * GRID.vel) / GRID.vel;
export const snapDir = (v: number) => Math.round(v * GRID.dir) / GRID.dir;
export const snapStamina = (v: number) => Math.round(v * GRID.stamina) / GRID.stamina;

/** Yaw as a u16 fraction of a turn. */
export function yawToU16(yaw: number): number {
  const turns = (((yaw / TAU) % 1) + 1) % 1;
  return Math.round(turns * 65536) & 0xffff;
}

/** Inverse of yawToU16, mapped into (-π, π]. */
export function yawFromU16(u: number): number {
  const y = (u / 65536) * TAU;
  return y > Math.PI ? y - TAU : y;
}

export const snapYaw = (yaw: number) => yawFromU16(yawToU16(yaw));
